import GlobalStyle from "./components/GlobalStyles";
import { useState } from "react";
import menuData from "./menuData";
import { BrowserRouter as Router, Route } from "react-router-dom";

import Home from "./pages/Home";
import NavBar from "./components/NavBar";
import Product from "./pages/Product";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";

function App() {
  const dataMenu = menuData();
  const [subMenuList, setSubMenuindex] = useState([]);

  const subMenuIndexHandler = () => {
    setSubMenuindex(dataMenu[0].subMenu);
  };

  const subMenuIndexHandlerLogin = () => {
    setSubMenuindex([]);
  };
  return (
    <Router>
      <div className="App">
        <GlobalStyle />
        <header>
          <NavBar
            setSubMenuindex={setSubMenuindex}
            subMenuList={subMenuList}
            dataMenu={dataMenu}
          />
        </header>

        <div onMouseEnter={subMenuIndexHandler}>
          <Route path="/" exact component={Home} />
        </div>

        <Route
          path="/products"
          setSubMenuindex={setSubMenuindex}
          exact
          component={Product}
        />

        <div onMouseOver={subMenuIndexHandlerLogin}>
          <Route path="/login" exact component={Login} />
        </div>

        <div onMouseOver={subMenuIndexHandlerLogin}>
          <Route path="/signup" exact component={SignUp} />
        </div>
      </div>
    </Router>
  );
}

export default App;
